import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { BelowDesktop, Desktop, Nav, LanguageSelector, Logo } from '@gsp/gusto-front-common'

import { telematLanguages } from '../../../i18n'

import './style.scss'

const Header = () => {
  const [isBurgerToggled, setIsBurgerToggled] = useState(false)
  const { acceptedLanguages = ['en'] } = telematLanguages

  const languageSelector = <LanguageSelector acceptedLanguages={acceptedLanguages} />

  return (
    <>
      <header data-testid="header" className="header">
        <div className="left_part">
          <a href={'/'}>
            <Logo />
          </a>
          <div className="header__disclaimer-container">
            <FormattedMessage id="allianz-trade-header-disclaimer" tagName="p" />
          </div>
        </div>
        <div className="right_part">
          <nav className="header__navigation">
            <Desktop>
              <Nav id="phone-contact" />
            </Desktop>
            <BelowDesktop>
              <div
                data-testid="header-burger"
                onClick={() => {
                  setIsBurgerToggled(!isBurgerToggled)
                }}
                className={`header__burger ${isBurgerToggled ? 'header__burger--isCross' : ''}`}
              >
                <div className={`header__burger-stripe ${isBurgerToggled ? 'header__burger-stripe--isCross' : ''}`} />
              </div>
            </BelowDesktop>
          </nav>
          <div>
            <Desktop>{languageSelector}</Desktop>
          </div>
        </div>
      </header>
      <hr className="header__separator" />
      <div
        data-testid="header-mobile-nav"
        className={`header__mobile-nav ${
          isBurgerToggled ? 'header__mobile-nav--toggled' : 'header__mobile-nav--hidden'
        }`}
      >
        <Nav id="phone-contact" />
      </div>
      {isBurgerToggled ? <hr className="header__separator" /> : ''}
    </>
  )
}

export default Header
